/**
 * @file AboutContent.jsx
 */

import { Typography } from '@mui/material';
import { dialogAlert } from './common/DialogProvider';
import ExternalLink from './common/ExternalLink';

export default function AboutContent() {
    return (
        <Typography variant="body1" component="div" gutterBottom>
            <div style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '1em' }}>
                <strong>Boltzmann Maps:</strong>
                <br />
                Distributions of binding configurations
                <br />
                of chemical fragments or water molecules
                <br />
                on the surface of macromolecules,
                <br />
                conforming to Boltzmann energy statistics.
            </div>
            <div>
                Developed at Conifer Point Pharmaceuticals
                {' '}
                (
                <ExternalLink
                    link="https://www.coniferpoint.com"
                    style={{ color: 'var(--marketing-blue)' }}
                    skipIcon
                >
                    www.coniferpoint.com
                </ExternalLink>
                ).
            </div>
            <div>
                Based on Grand Canonical Monte Carlo simulations
                and fragment-based design tools developed at BioLeap, Inc.
            </div>
            <div style={{ marginTop: '1em' }}>
                BMaps is made possible by many powerful libraries, packages, and tools
                which are generously licensed for community use.
                See
                {' '}
                <ExternalLink
                    link="https://www.boltzmannmaps.com/software-acknowledgements"
                    style={{ color: 'var(--marketing-blue)' }}
                    skipIcon
                >
                    Software Acknowledgements
                </ExternalLink>
                .
            </div>
        </Typography>
    );
}

export function showAbout() {
    dialogAlert('About', <AboutContent key="about-content" />, { Icon: null });
}
